import React, { useState, useEffect, forwardRef } from "react";
import {
  SwipeableDrawer, IconButton
} from '@material-ui/core';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

import MybilioTextLogoBronze from "../../../resources/logo/mybilio_text_logo_bronze.js";
import IcClose from "../../../resources/icons/ic_close.js";

import I18n from "../../../base/i18n.js";

import Routes from "../../routes.js";

import { ProjectsAnchor } from "../../pages/index/constants.js";

const blockStyles = makeStyles(theme => ({
  root: {
    "& .MuiBackdrop-root": {
      backgroundColor: "transparent",
    }
  },
  menu: {
    backgroundColor: theme.palette.white,
    width: "240px",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center"
  },
  close: {
    width: "24px",
    height: "24px",
    top: "32px",
    right: "16px",
    position: "absolute",
  },
  menuRow: {
    padding: "2px 24px",
    margin: "0px"
  },
  logoRow: {
    marginBottom: "40px"
  },
  logo: {
    width: "112px",
    height: "60px"
  },
  list: {
    listStyle: "none",
    padding: "0px",
    margin: "0px"
  },
  linkRow: {
    padding: "0px 24px",
    "& + &": {
      borderTop: `1px solid ${theme.palette.grayDisable}`
    }
  },
  link: {
    display: "block",
    color: theme.palette.greenMain,
    textDecoration: "none",
    padding: "18px 24px",
    textTransform: "uppercase",
    fontSize: "16px",
    lineHeight: "20px",
    margin: "0px -24px",
    "& span": {
      display: "block"
    },
    "& span + span": {
      marginTop: "10px"
    }
  },
  linkSubtitle: {
    color: theme.palette.grayText,
    fontSize: "12px"
  },
  phone: {
    fontSize: "16px"
  },
  activeLink: {
    backgroundColor: theme.palette.grayBg
  },
}));

const LeftMenu = forwardRef((props, ref) => {
  const classes = blockStyles();
  const { onClose, menus } = props;

  const [open, setOpen] = useState(props.open);

  useEffect(() => {
    setOpen(props.open)
  }, [props.open]);

  const close = () => {
    onClose();
  }

  const onClickLink = () => {
    close();
  }

  const menuList = (menus) => {
    return menus.map(({ name, slug }) =>
      <div key={slug}>
        <li key={slug} className={ clsx(classes.menuRow, classes.linkRow) } >
          <HashLink to={Routes.page(slug)}
                    className = { classes.link }
                    activeClassName = { classes.activeLink }
                    onClick = { onClickLink } >
            {name}
          </HashLink>
        </li>
        {subMenus(slug)}
      </div>
    )
  }

  const mainMenus = (key) => {
    const filteredMenus = menus.filter(({menu}) => { return menu == key })
    if(filteredMenus.length == 0)
      return <React.Fragment />
    return menuList(filteredMenus)
  }

  const subMenus = (key) => {
    const filteredMenus = menus.filter(({menu}) => { return menu == key })
    if(filteredMenus.length == 0)
      return <React.Fragment />
    return <ul className = { clsx(classes.list, classes.linkRow) }>
             {menuList(filteredMenus)}
           </ul>
  }

  return (
    <SwipeableDrawer anchor = { "left" }
            open = { open }
            ref = { ref }
            onOpen = { () => {} }
            onClose = { close }
            className = { classes.root } >
      <div className = { classes.menu } >
        <IconButton className = { classes.close }
                    onClick = { close } >
          <IcClose />
        </IconButton>
        <div className = { clsx(classes.menuRow, classes.logoRow )} >
          <NavLink to = { Routes.index() }
                   onClick = { onClickLink } >
            <MybilioTextLogoBronze className = { classes.logo } />
          </NavLink>
        </div>
        <ul className = { classes.list } >
          <li className = { clsx(classes.menuRow, classes.linkRow) } >
            <HashLink to = { Routes.index({anchor: ProjectsAnchor}) }
                      className = { classes.link }
                      activeClassName = { classes.activeLink }
                      onClick = { onClickLink } >
              { I18n.t("shared.projects") }
            </HashLink>
          </li>
          {mainMenus('main')}
        </ul>
      </div>
    </SwipeableDrawer>
  );
});

export default LeftMenu;
